import { JCMSCTA, JCMSCTAProps } from "./../JCMSCTA";
import React, { Children, FC, Fragment, useMemo } from "react";
import './JBox.scss';
import { Divider } from "antd";
export interface JBoxProps {
    cta?: JCMSCTAProps[]
}
export const JBox: FC<JBoxProps> = props => {
    const childrenArray = useMemo(() => Children.toArray(props.children), [props.children])

    return (
        <div className="jbox">
            <div className="jbox-container">
                {
                    childrenArray.map((children, i) => (
                        <Fragment key={i}>
                            <div className="jbox-row">
                                {
                                    children
                                }
                            </div>
                            {
                                i < (childrenArray.length - 1) && (
                                    <div className="jbox-row">
                                        <Divider />
                                    </div>
                                )
                            }
                        </Fragment>
                    ))
                }
                {
                    props.cta?.length && (
                        <div className="jbox-cta">
                            {
                                props.cta.map((cta, i) => (
                                    <JCMSCTA {...cta} key={i} />

                                ))
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )
}